import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet, Dimensions, Image } from 'react-native';
import { useTranslation } from 'react-i18next';
import { languageService } from '../services';

// Eigenschappen definiëren (anders wordt typescript boos en gaat ie zeuren)
interface Eigenschappen {
    onLanguageSelected: () => void;
}

const { width: schermBreedte } = Dimensions.get('window');

const FirstRunLanguageScreen: React.FC<Eigenschappen> = ({ onLanguageSelected }) => {
    const { i18n } = useTranslation();

    // Taal instellen en opslaan
    const verwerkTaalKeuze = async (taal: 'nl' | 'en') => {
        try {
            // Dit roept de service aan, die het opslaat in de storage
            await languageService.setLanguage(taal);
            // En doorrr...
            onLanguageSelected();
        } catch (fout) {
            console.error('Failed to set language:', fout);
            // Hopelijk gebeurt dit nooit
        }
    };

    return (
        <View style={stijlen.container}>
            <Text style={stijlen.titel}>Welkom bij NebulaTide</Text>
            <Text style={stijlen.subtitel}>Kies je taal / Choose your language</Text>

            <View style={stijlen.knoppenBak}>
                {/* Nederlands knopje */}
                <TouchableOpacity
                    style={stijlen.knop}
                    onPress={() => verwerkTaalKeuze('nl')}>
                    <Image
                        source={{ uri: '/assets/flags/nl.png' }}
                        style={stijlen.vlagPlaatje}
                        accessibilityLabel="Dutch Flag"
                    />
                    <Text style={stijlen.knopTekst}>Nederlands</Text>
                </TouchableOpacity>

                {/* Engels knopje */}
                <TouchableOpacity
                    style={stijlen.knop}
                    onPress={() => verwerkTaalKeuze('en')}>
                    <Image
                        source={{ uri: '/assets/flags/gb.png' }}
                        style={stijlen.vlagPlaatje}
                        accessibilityLabel="UK Flag"
                    />
                    <Text style={stijlen.knopTekst}>English</Text>
                </TouchableOpacity>
            </View>
        </View>
    );
};

const stijlen = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: '#F5F5F5',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
    },
    titel: {
        fontSize: 28,
        fontWeight: 'bold',
        marginBottom: 12,
        color: '#333',
        textAlign: 'center',
    },
    subtitel: {
        fontSize: 16,
        color: '#666',
        marginBottom: 48,
        textAlign: 'center',
    },
    knoppenBak: {
        width: '100%',
        gap: 16,
    },
    knop: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'white',
        padding: 20,
        borderRadius: 16,
        shadowColor: '#000',
        shadowOffset: {
            width: 0,
            height: 2,
        },
        shadowOpacity: 0.1,
        shadowRadius: 4,
        elevation: 3,
    },
    vlagPlaatje: {
        width: 32,
        height: 24,
        marginRight: 16,
        borderRadius: 4,
    },
    knopTekst: {
        fontSize: 18,
        fontWeight: '600',
        color: '#333',
    },
});

export default FirstRunLanguageScreen;
